import { set } from 'lodash';

export function isValidationError(error) {
  return error.type === 'ValidationError' && error.errors;
}

export function parseValidationErrors(errors) {
  if (!errors) return {};

  return errors.reduce((curr, acc) => {
    return set(curr, acc.param, acc.message);
  }, {});
}

export function transformApiErrorToFormik(error) {
  if (error && isValidationError(error)) {
    return {
      errors: parseValidationErrors(error.errors),
      status: error.message,
    };
  } else {
    return { errors: {}, status: error?.message || error };
  }
}
